import { DIC } from "@/const/dic";
import {
  validateChinese,
  // validateEmail,
  // validAccountAndPassword,
} from "@/util/validate";
// import { baseUrl } from "@/config/env";

const validateName = (rule, value, callback) => {
  if (!validateChinese(value) || value.length > 30 || value.length < 1) {
    callback(new Error("名称为1-30位中文"));
  } else {
    callback();
  }
};
const validateNumber = (rule, value, callback) => {
  // 将输入的值转换为数字
  const numericValue = Number(value);
  if (isNaN(numericValue) || numericValue < 0) {
    callback(new Error("请输入数字"));
  } else {
    callback();
  }
};

/* const validatorEmail = (rule, value, callback) => {
  if (!validateEmail(value)) {
    callback(new Error("请输入正确的邮箱地址"));
  } else {
    callback();
  }
};
const validatorPassword = (rule, value, callback) => {
  if (!validAccountAndPassword(value)) {
    callback(new Error("请输入由数字和字母组成的6-16位密码"));
  } else {
    callback();
  }
};

const validatorAccount = (rule, value, callback) => {
  if (!validAccountAndPassword(value)) {
    callback(new Error("请输入由数字和字母组成的6-16位账号"));
  } else {
    callback();
  }
}; */

export const shopTableOption = {
  align: "center",
  menuAlign: "center",
  headerAlign: "center",
  border: true,
  expand: false,
  stripe: false,
  showHeader: true,
  // align: 'center',
  index: false,
  selection: true,
  menu: true,
  columnBtn: false,
  refreshBtn: true,
  saveBtn: false,
  updateBtn: false,
  cancelBtn: false,
  addBtn: false,
  delBtn: false,
  editBtn: false,
  page: false,
  dialogClickModal: false,
  menuWidth: "400",
  labelWidth: "100",
  // menuType: 'menu',
  defaultSort: {
    prop: "createTime",
    order: "descending",
  },
  column: [
    {
      label: "账号",
      prop: "account",
      placeholder: "请输入账号",
      search: true,
      type: "input",
      editVisdiplay: false,
      rules: [
        {
          required: true,
          trigger: "blur",
          message: "请输入账号",
        },
      ],
    },
    {
      label: "手机号码",
      prop: "mobile",
      placeholder: "请选择手机号码",
      type: "input",
      rules: [
        {
          required: true,
          trigger: "blur",
          max: 11,
          min: 11,
          message: "请选择手机号码",
        },
      ],
    },
    // {
    //     label: "邮箱",
    //     prop: "eMail",
    //     type: "input"
    // },
    {
      label: "登录密码",
      placeholder: "请输入员工的登录密码",
      prop: "password",
      hide: true,
      type: "password",
      editVisdiplay: false,
    },
    {
      label: "店铺名称",
      prop: "shopName",
      placeholder: "请输入店铺名称",
      search: true,
      type: "input",
      rules: [
        {
          required: true,
          trigger: "blur",
          validator: validateName,
        },
      ],
    },
    {
      label: "商户编码",
      prop: "merchantCode",
      placeholder: "请输入商户编码",
      type: "input",
      maxlength: 64,
      showWordLimit: true,
    },
    {
      label: "店铺简称",
      prop: "abbreviation",
      placeholder: "请输入店铺简称",
      search: true,
      type: "input",
      maxlength: 20,
      showWordLimit: true,
      rules: [
        {
          max: 20,
          trigger: "blur",
          message: "简称最多20个字符",
        },
      ],
    },
    {
      label: "区域",
      prop: "region",
      type: "input",
      search: true,
      rules: [
        {
          required: true,
          trigger: "blur",
          message: "请输入区域",
        },
      ],
    },
    {
      label: "店铺法人",
      prop: "name",
      placeholder: "请输入店铺法人姓名",
      search: true,
      type: "input",
      rules: [
        {
          required: true,
          trigger: "blur",
          validator: validateName,
        },
      ],
    },
    {
      label: "未支付限制",
      prop: "maxUnpaidOrders",
      placeholder: "请输入未支付订单数量限制",
      search: false,
      span: 24,
      type: "input",
      rules: [
        {
          required: true,
          trigger: "blur",
          validator: validateNumber,
        },
      ],
    },
    {
      label: "身份证正面",
      prop: "dutyIdCardFrontImg",
      span: 24,
      hide: true,
      formsolt: true,
      solt: true,
      row: true,
    },
    {
      label: "身份证反面",
      prop: "dutyIdCardBackImg",
      span: 24,
      hide: true,
      formsolt: true,
      solt: true,
      row: true,
    },
    {
      label: "营业执照",
      prop: "businessLicense",
      span: 24,
      hide: true,
      formsolt: true,
      solt: true,
      row: true,
    },
    {
      label: "省份",
      prop: "provinceName",
      hide: true,
      formsolt: true,
    },
    {
      label: "城市",
      prop: "cityName",
      hide: true,
      formsolt: true,
    },
    {
      label: "地区",
      prop: "areaName",
      hide: true,
      formsolt: true,
    },
    {
      label: "店铺地址",
      placeholder: "请输入店铺地址",
      prop: "address",
      search: true,
      type: "input",
    },
    {
      label: "店铺地址标记",
      prop: "provincesPoInt",
      span: 24,
      solt: true,
      hide: true,
      formsolt: true,
    },
    {
      label: "状态",
      prop: "approveStatus",
      type: "radio",
      dicData: DIC.SHOP_APPROVE_STATUS,
      sortable: true,
      addVisdiplay: false,
      editVisdiplay: false,
    },
    {
      label: "报单开关",
      prop: "orderEnabled",
      type: "radio",
      dicData: DIC.ORDER_ENABLED,
      search: true,
      sortable: true,
      addVisdiplay: false,
      editVisdiplay: false,
    },
    {
      label: "创建时间",
      prop: "createTime",
      type: "datetime",
      sortable: true,
      format: "yyyy-MM-dd HH:mm:ss",
      addVisdiplay: false,
      editVisdiplay: false,
    },
    {
      label: "创建人",
      prop: "createBy",
      type: "input",
      addVisdiplay: false,
      editVisdiplay: false,
    },

    {
      label: "更新时间",
      prop: "updateTime",
      type: "datetime",
      format: "yyyy-MM-dd HH:mm:ss",
      hide: true,
      addVisdiplay: false,
      editVisdiplay: false,
    },
    {
      label: "更新人",
      prop: "updateBy",
      type: "input",
      hide: true,
      addVisdiplay: false,
      editVisdiplay: false,
    },
    {
      label: "是否删除",
      prop: "deleteFlag",
      type: "radio",
      hide: true,
      addVisdiplay: false,
      editVisdiplay: false,
      dicData: DIC.DELETE_FLAG,
    },
    {
      label: "备注",
      prop: "remarks",
      type: "textarea",
      span: 24,
      hide: true,
      max: 255,
    },
  ],
};
